import React from "react";
import { motion } from "framer-motion";
import {
  Linkedin,
  Mail,
  Phone,
  ChevronDown,
  Sparkles,
  Code2,
  TrendingUp,
  Cpu,
  Database,
  Smartphone,
  Globe,
} from "lucide-react";

const Hero = () => {
  return (
    <section
      id="hero"
      className="min-h-screen flex items-center relative bg-gray-50 pt-16 md:pt-28 px-4 sm:px-6 lg:px-8"
    >
      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 items-center">

          {/* LEFT CONTENT */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-6"
          >
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border shadow-sm text-sm">
              <Sparkles className="w-4 h-4 text-yellow-500" />
              <span className="font-medium">
                Front-End Developer & Digital Marketer
              </span>
            </div>

            {/* Heading */}
            <h1 className="text-4xl md:text-5xl xl:text-6xl font-bold leading-tight text-gray-900">
              Hi, I’m{" "}
              <span className="block text-blue-600 mt-2">
                Prasad Savadatti
              </span>
            </h1>

            <p className="text-lg text-gray-600 max-w-xl">
              Digital Marketing Specialist with strong experience in SEO, lead
              generation, and front-end development. I help businesses grow
              visibility, traffic, and conversions.
            </p>

            {/* Stats */}
            <div className="flex gap-8">
              {[
                { value: "4+", label: "Years Experience" },
                { value: "20+", label: "Projects" },
                { value: "100%", label: "Client Satisfaction" },
              ].map((stat, i) => (
                <div key={i}>
                  <div className="text-3xl font-bold text-gray-900">
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-500">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Contact */}
            <div className="grid sm:grid-cols-2 gap-4 max-w-xl">
              <div className="flex items-center gap-3 p-3 bg-white rounded-xl shadow-sm">
                <Mail className="w-5 h-5 text-blue-600" />
                <span className="text-sm text-gray-700">
                  prasad.savadatti@gmail.com
                </span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-white rounded-xl shadow-sm">
                <Phone className="w-5 h-5 text-blue-600" />
                <span className="text-sm text-gray-700">
                  +91-6361056819
                </span>
              </div>
            </div>

            {/* CTA */}
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="https://www.linkedin.com/in/prasad-savadatti-9262a8a5/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3 bg-blue-600 text-white rounded-full font-semibold shadow-md hover:bg-blue-700 transition"
            >
              <Linkedin className="w-5 h-5" />
              View LinkedIn
            </motion.a>
          </motion.div>

          {/* RIGHT CARD */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative"
          >
            <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 space-y-6">

              {/* Header */}
              <div className="flex justify-between items-center">
                <div className="flex gap-2">
                  <span className="w-3 h-3 bg-red-500 rounded-full"></span>
                  <span className="w-3 h-3 bg-yellow-500 rounded-full"></span>
                  <span className="w-3 h-3 bg-green-500 rounded-full"></span>
                </div>
                <Code2 className="w-6 h-6 text-blue-600" />
              </div>

              {/* Tech Stack */}
              <div>
                <h3 className="font-semibold mb-2 text-gray-900">
                  Tech Stack
                </h3>
                <div className="flex flex-wrap gap-2">
                  {["React", "Tailwind", "JavaScript", "SEO", "Node.js"].map(
                    (tech) => (
                      <span
                        key={tech}
                        className="px-3 py-1 text-sm bg-gray-100 rounded-full text-gray-700"
                      >
                        {tech}
                      </span>
                    )
                  )}
                </div>
              </div>

              {/* Current Role */}
              <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl">
                <TrendingUp className="w-6 h-6 text-blue-600" />
                <div>
                  <div className="text-sm text-gray-500">
                    Currently Working
                  </div>
                  <div className="font-semibold text-gray-900">
                    Digital Marketing Executive
                  </div>
                  <div className="text-sm text-gray-500">
                    Urban Nest Properties
                  </div>
                </div>
              </div>

              {/* Skills Icons */}
              <div className="grid grid-cols-4 gap-4 text-center">
                <Cpu className="mx-auto text-blue-500" />
                <Globe className="mx-auto text-green-500" />
                <Database className="mx-auto text-purple-500" />
                <Smartphone className="mx-auto text-pink-500" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll */}
      <motion.div
        animate={{ y: [0, 8, 0] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
        className="absolute bottom-6 left-1/2 -translate-x-1/2"
      >
        <ChevronDown className="w-6 h-6 text-gray-400" />
      </motion.div>
    </section>
  );
};

export default Hero;
